<template>
	<div class="c c-background">
		<div class="box">
			<div class="card w-50" v-for="item in dataList" :key="item.id">
				<div class="center">
					<div class="log"><img :src="item.img" alt="" /></div>
					<div class="title">
						<div class="tlt">{{ item.tit }}</div>
						<div class="introduce">{{ item.introduce }}</div>
					</div>
				</div>
				<div class="border" v-if="!item.btnAndroid"></div>
				<div class="btn btnPc" v-if="!item.btnAndroid">
					<div class="btmItem" v-for="(i, idx) in item.btn" :key="idx" :style="{
                            color: i.textColor ? i.textColor : '#fff',
                            'background-color': i.bgColor ? i.bgColor : '#fff',
                            border: i.border ? i.border : '',
                        }" @click="copyAndDownload(i)">
						<div>{{ i.tit }}</div>
					</div>
				</div>
				<div class="btn" v-else>
					<span class="btnItem" @click="openImgUrl(item.btn.img)">
						{{ item.btn.AndroidText }}
						<div class="imgCode">
							<img :src="item.btn.img" alt="" />
						</div>
					</span>
				</div>
				<div :class="['tip', item.tip == 'win版' ? 'winTip' : '']">{{ item.tip }}</div>
			</div>
		</div>
	</div>
</template>

<script>
  import QRCode from "qrcode";
  import btnPc from './btnPc.js'
	import {
		Toast
	} from 'vant';

	function openImageInNewWindow(imageUrl) {
		var newWindow = window.open('', '_blank');
		newWindow.document.write(
			"<html><head><title>Image</title></head><body style='text-align: center;'><img src='" +
			imageUrl +
			"'></body></html>"
		);
	}
	export default {
		data() {
			return {
				dataList: btnPc,
				apkUrl:''
			};
		},
		created() {
			this.getUrl()
		},
		methods: {
			async getUrl(){
				// 
				let dataList = this.dataList
				for (let index = 0; index < this.dataList.length; index++) {
					if(!Array.isArray(this.dataList[index].btn)){
						const img =  await QRCode.toDataURL(dataList[index].btn.Url)
						dataList[index].btn.img = img
					}
				}
				this.dataList = dataList
				console.log(dataList);
			},
			async copyAndDownload(i) {
				if (i.copyUrl) return this.copy(i.copyUrl);
				if (this.browser) {
				    return;
				}
				window.location.href = i.downloadUrl
			},
			copy(copyUrl) {
				let input = document.createElement('input');
				input.value = copyUrl || '文件不存在';
				document.body.appendChild(input);
				input.select();
				document.execCommand('copy');
				document.body.removeChild(input);
				Toast({
					message: '复制成功',
						duration: 3000,
					});
				},
			openImgUrl(url) {
				// 在新的浏览页打开图片
				openImageInNewWindow(url);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.c {
		height: 100vh;
		overflow-y: auto;
		padding: 0 15px;
	}

	.tit {
		font-size: 14px;
		color: #333333;
	}

	.card {
		position: relative;
		margin-top: 15px;
		width: 407px;
		height: 210px;
		padding: 15px;
		border-radius: 6px;
		background-color: #fff;

		.tip {
			position: absolute;
			top: 0;
			right: 0;
			border-radius: 0 6px 0 20px;
			background-color: #f4f9ec;
			text-align: center;
			line-height: 28px;
			color: #97c14a;
			width: 68px;
			height: 28px;
		}

		.winTip {
			color: #0178d7 !important;
			background-color: #e5f1fb !important;
		}

		.center {
			display: flex;

			.log {
				padding: 15px 0 10px;

				img {
					width: 67px;
					height: 67px;
				}
			}

			.title {
				margin-left: 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.tlt {
					font-size: 16px;
					color: #000;
					font-weight: 600;
				}

				.introduce {
					margin-top: 10px;
					font-size: 12px;
					color: #333333;
				}
			}
		}

		.border {
			margin-top: 20px;
			margin-bottom: 10px;
			height: 1px;
			background-color: #e4e5e6;
		}

		.btnPc {
			margin-top: 20px;
		}

		.btn {
			display: flex;
			justify-content: end;
			height: 35px;
			margin-right: 10px;

			.btmItem {
				cursor: pointer;
				margin-left: 10px;
				line-height: 35px;
				padding: 0 15px;
				border-radius: 28px;
			}

			.btnItem {
				position: relative;
				width: 100%;
				height: 48px;
				text-align: left;
				margin-top: 30px;
				line-height: 48px;
				background: #fff0e6;
				color: #ff690e;
				cursor: pointer;
				padding-left: 60px;
				.imgCode {
					position: absolute;
					background-color: #fff;
					top: -40px;
					width: 124px;
					height: 124px;
					right: 2%;

					img {
						width: 124px;
						height: 124px;
					}
				}
			}
		}
	}

	.box {
		display: grid;
		padding: 0 200px;
		// 3列3行
		grid-template-columns: repeat(3, 1fr );
		gap: 50px 50px;
		height: 210px;
	}

	.c-background {
		display: flex;
		justify-content: center;
		height: 100vh;
		background: url('../../../assets/sy-pc.png') no-repeat 100% 100%/100% 100%;
	}
</style>